import React from "react";
import classNames from "classnames";
import { BemHelper } from "../utils/BemHelper";

// Image
import noImage from "./images/no-ava.svg";
import loadingStatusImage from "./images/loading-status.svg";

const bem = new BemHelper("avatar");

type Props = {
  imageSrc?: string | null;
  width?: number;
};

export const Avatar: React.FC<Props> = ({ imageSrc, width = 83 }) => {
  return (
    <div
      className={classNames(bem.block())}
      style={{
        width: width + width * 0.27,
        height: width + width * 0.27,
      }}
    >
      <img className={classNames(bem.element("status"))} src={loadingStatusImage} alt='' />
      <div
        className={classNames(bem.element("person"))}
        style={{ width: width, height: width, background: `url("${imageSrc ?? noImage}")` }}
      />
    </div>
  );
};
